import * as React from 'react';

interface IAeroPhotoTourFrameProps {
  url: string;
}

export const AeroPhotoTourFrame: React.FC<IAeroPhotoTourFrameProps> = ({ url }) => {
  return (
    <iframe
      frameBorder={0}
      src={url}
      width="100%"
      height="100%"
      sandbox="allow-scripts allow-same-origin"
      referrerPolicy="no-referrer"
      allowFullScreen
    />
  );
};
